export const HIGHLIGHT_COLORS = [
  { name: 'Yellow', value: '#fef3c7' },
  { name: 'Pink', value: '#fce7f3' },
  { name: 'Green', value: '#d1fae5' },
  { name: 'Blue', value: '#dbeafe' },
  { name: 'Purple', value: '#ede9fe' },
  { name: 'Orange', value: '#ffedd5' },
];

export const TEXT_COLORS = [
  { name: 'Default', value: '' },
  { name: 'Gray', value: '#6b7280' },
  { name: 'Red', value: '#dc2626' },
  { name: 'Orange', value: '#ea580c' },
  { name: 'Yellow', value: '#ca8a04' },
  { name: 'Green', value: '#16a34a' },
  { name: 'Blue', value: '#2563eb' },
  { name: 'Purple', value: '#9333ea' },
  { name: 'Pink', value: '#db2777' },
];

export const FONT_FAMILIES = [
  { name: 'Default', value: '' },
  {
    name: 'Sans-serif',
    value: 'ui-sans-serif, system-ui, -apple-system, sans-serif',
  },
  {
    name: 'Serif',
    value: 'ui-serif, Georgia, Cambria, "Times New Roman", serif',
  },
  {
    name: 'Mono',
    value: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  },
];

export const COMMON_EMOJIS = [
  '📝',
  '📄',
  '📚',
  '📌',
  '📔',
  '🗒️',
  '🗂️',
  '✨',
  '💡',
  '🚀',
  '🎯',
  '🧠',
  '🛠️',
  '🐛',
  '🌱',
  '🔥',
  '⭐',
  '👋',
  '☕',
  '🎨',
];
